(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (scope = document) => {
    const cartItems = scope.querySelector('cart-items');
    if (cartItems && !cartItems.dataset.cinemaObserved) {
      cartItems.dataset.cinemaObserved = 'true';
      const updateCount = () => {
        const count = Array.from(cartItems.querySelectorAll('input[name="updates[]"]')).reduce((sum, input) => sum + Number(input.value || 0), 0);
        document.querySelectorAll('.vera-cart-count').forEach(item => { item.textContent = String(count); });
      };
      new MutationObserver(updateCount).observe(cartItems, { childList: true, subtree: true });
      updateCount();
    }
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const image = root.querySelector('.mv-gallery-primary');
      const thumbnails = root.querySelectorAll('[data-gallery-image]');
      const setImage = (url, alt) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.src = url;
        if (alt) image.alt = alt;
      };
      thumbnails.forEach(button => button.addEventListener('click', () => {
        setImage(button.dataset.galleryImage, button.dataset.galleryAlt);
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const select = root.querySelector('[data-product-variant]');
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        root.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-compare-price]');
        if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
        setImage(option.dataset.image);
        const buy = root.querySelector('[data-product-buy]');
        const available = option.dataset.available === 'true';
        buy.disabled = !available;
        buy.querySelector('span').textContent = available ? buy.dataset.buyLabel : buy.dataset.soldLabel;
      });
    });
    scope.querySelectorAll('[data-film]').forEach(film => {
      if (film.dataset.initialized) return;
      film.dataset.initialized = 'true';
      const video = film.querySelector('video');
      const button = film.querySelector('[data-film-toggle]');
      if (!video) { if (button) button.hidden = true; return; }
      let manualPause = false;
      let inView = false;
      const prepare = () => {
        if (video.dataset.videoSrc && !video.getAttribute('src')) { video.src = video.dataset.videoSrc; video.load(); }
      };
      const state = () => {
        const playing = !video.paused;
        if (!button) return;
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        button.querySelector('[data-control-label]').textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.querySelector('[data-control-symbol]').textContent = playing ? 'Ⅱ' : '▷';
      };
      const play = () => { prepare(); video.play().catch(() => state()); };
      video.addEventListener('playing', () => { film.classList.add('is-playing'); state(); });
      video.addEventListener('pause', state);
      video.addEventListener('error', () => { film.classList.remove('is-playing'); if (button) button.hidden = true; });
      if (button) button.addEventListener('click', () => {
        if (video.paused) { manualPause = false; play(); } else { manualPause = true; video.pause(); }
      });
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          inView = entry.isIntersecting;
          if (inView && !motion.matches && !manualPause) play(); else if (!inView) video.pause();
        }
      }, { threshold: .18 });
      observer.observe(film);
      const updateMotion = () => { if (motion.matches) video.pause(); else if (inView && !manualPause) play(); };
      motion.addEventListener('change', updateMotion);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause(); else if (inView && !motion.matches && !manualPause) play();
      });
      state();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
